import {AppState} from '../store';
import {ITableCell} from '../../@crema/components/Table/TableItem';
import {percentageFormatter} from '../../utils/numberFormatter';
import {formatEther} from 'utils/formatEther';
import {format} from 'date-fns';
import lodash from 'lodash';

export const getPriceCorrectionLogs = (state: AppState) =>
  state.priceCorrectionLogs;

export const getPriceCorrectionLogsRows = (
  state: AppState,
): Array<ITableCell[]> => {
  const {priceCorrectionLogs} = state;

  const priceCorrectionLogsRows: Array<ITableCell[]> = [];
  priceCorrectionLogs.data &&
    priceCorrectionLogs.data.items.map((priceCorrectionLog) => {
      priceCorrectionLogsRows.push([
        {value: priceCorrectionLog.exchangeSlug},
        {value: formatEther(priceCorrectionLog.targetPrice, 3)},
        {value: formatEther(priceCorrectionLog.lastPrice, 3)},
        {value: priceCorrectionLog.actor},
        {
          value: format(
            new Date(priceCorrectionLog.timestamp),
            'H:mm  d MMMM yyyy',
          ),
        },
      ]);
    });

  return priceCorrectionLogsRows;
};

export const getEstimateBacking = (state: AppState) => {
  const estimatedBacking =
    state.priceCorrectionLogs.backingEstimate?.estimatedBacking;
  return !lodash.isNil(estimatedBacking)
    ? `This will change backing to ${percentageFormatter(estimatedBacking)}`
    : 'Failed to load backing estimate';
};
